import { render } from "./WhoWeAreSection.vue?vue&type=template&id=4ac330b3&scoped=true"
import script from "./WhoWeAreSection.vue?vue&type=script&lang=js"
export * from "./WhoWeAreSection.vue?vue&type=script&lang=js"

import "./WhoWeAreSection.vue?vue&type=style&index=0&id=4ac330b3&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ac330b3"]])

export default __exports__